import React, { useState } from "react";
import "./navbar.css";
import styled from "styled-components";
import { motion } from "framer-motion/dist/framer-motion";
import { GiHamburgerMenu } from "react-icons/gi";
import { GiTireIronCross } from "react-icons/gi";

const Section = styled.section`
  height: 10vh;
  display: flex;
  flexdirection: row;
  align-items: center;
  padding: 0px 30px;
  padding-top: 10px;
  justify-content: space-between;
  background: black;

  @media screen and (max-width: 650px) {
    padding: 1rem;
  }
`;
const ContainerLeft = styled.div`
  h1 {
    color: white;
    font-size: 30px;
    font-weight: 600;
  }

  @media screen and (max-width: 650px) {
    h1 {
      font-size: 20px;
    }
  }
`;
const ContainerRight = styled.div``;

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  const fadeLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  return (
    <Section>
      <ContainerLeft>
        <motion.h1
          variants={fadeLeft}
          initial="hidden"
          animate="visible"
          transition={{ duration: 1 }}
        >
          The TechVerse
        </motion.h1>
      </ContainerLeft>
      <ContainerRight>
        <motion.a
          className="nav-links"
          whileTap={{
            scale: 0.95,
            opacity: 0,
          }}
          transition={{ duration: 1 }}
          href="#home"
        >
          Home
        </motion.a>
        <motion.a
          className="nav-links"
          whileTap={{
            scale: 0.95,
            opacity: 0,
          }}
          transition={{ duration: 1 }}
          href="#about"
        >
          About
        </motion.a>
        <motion.a
          className="nav-links"
          whileTap={{
            scale: 0.95,
            opacity: 0,
          }}
          transition={{ duration: 1 }}
          href="#services"
        >
          Services
        </motion.a>
        <motion.a
          className="nav-links"
          whileTap={{
            scale: 0.95,
            opacity: 0,
          }}
          transition={{ duration: 1 }}
          href="#contacts"
        >
          Contacts
        </motion.a>
      </ContainerRight>

      <div className="navbar-smallscreen">
        <GiHamburgerMenu
          color="#fff"
          fontSize={27}
          onClick={() => setToggleMenu(true)}
        />

        {toggleMenu && (
          <div className="navbar-smallscreen_overlay">
            <GiTireIronCross
              fontSize={27}
              className="overlay__close"
              onClick={() => setToggleMenu(false)}
            />
            <ul className="navbar-smallscreen_links">
              <li>
                <a href="#home">Home</a>
              </li>
              <li>
                <a href="#about">About</a>
              </li>
              <li>
                <a href="#services">Services</a>
              </li>
              <li>
                <a href="#contacts">Contacts</a>
              </li>
            </ul>
          </div>
        )}
      </div>
    </Section>
  );
};

export default Navbar;
